import { useEffect, useRef } from 'react'

import { useLocation } from 'react-router-dom'

interface RouteTrackingOptions {
  /** Handler for any route change */
  onRouteChange?: (pathname: string, prevPathname: string) => void;
  /** Enable logging of route changes */
  enableLogging?: boolean;
}

export const useRouteTracking = (options: RouteTrackingOptions = {}) => {
  const location = useLocation()
  const prevPathnameRef = useRef(location.pathname)

  useEffect(() => {
    const currentPath = location.pathname
    const prevPath = prevPathnameRef.current

    // Skip if path hasn't changed
    if (prevPath === currentPath) {
      return
    }

    // Logging route changes
    if (options.enableLogging) {
      console.log(`[RouteTracking] Route changed from "${prevPath}" to "${currentPath}"`)
    }

    // General route change handler
    if (options.onRouteChange) {
      options.onRouteChange(currentPath, prevPath)
    }

    // Update previous path
    prevPathnameRef.current = currentPath
  }, [location.pathname, options])
}
